
import React, { FC, useRef, useState } from 'react';
import { AutoComplete } from 'antd';
import { debounce } from 'lodash';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';
import styles from './index.module.less';
import memo from '../memo';

interface OpenApiInputProps {
  API: {
    FetchAPI?: any;
  };
  field: any;
  value?: string;
  onChange?: Function;
  form: any;
  config: Record<any, any>;
  columnFrom: any;
  storeValue: any;
  rowsData: any;
  disabled?: boolean;
  allowClear?: boolean;
}

export const AutoCompleteInput: FC<OpenApiInputProps> = ({
  API,
  field,
  value,
  onChange,
  disabled,
  allowClear,
}) => {
  const { isUpperCase, isOpenReg, charaterList, isOpenSearch, treeId, dataKey, label, isOnlyRead } = field?.bizConfig || {};
  const [options, setOptions] = useState<any[]>([]);

  const searchData = (value: any): any => {
    const searVal = value.replace(/'/g, '');
    const params: Record<any, any> = {
      moduleID: dataKey,
      namespaceID: treeId,
      limit: 10,
      filter: `${label} ILIKE '%${searVal}%'`,
    };
    getModuleRecordListCache(API?.FetchAPI, treeId, dataKey, params).then((res: any) => {
      const { set = [] } = res || {};
      const searchOption: any[] = [];
      set.forEach((item: any) => {
        searchOption.push({
          disabled,
          label: item?.values.find((record: any) => record.name === label)?.value,
          value: item?.values.find((record: any) => record.name === label)?.value,
        })
      })
      setOptions(searchOption);
    });
  }

  const setServicesValueDebounced = useRef(debounce(searchData, 500));

  const onSearch = (searchText: string) => {
    if (!(searchText?.length > 0) || !isOpenSearch) {
      return;
    }
    setServicesValueDebounced.current(searchText);
  };

  const onSelect = (data: string) => {
    console.log('onSelect', data);
  };

  const changeInput = (data: string) => {
    let sendData = isUpperCase ? data.toUpperCase() : data;
    if (isOpenReg) {
      charaterList.forEach((item: any) => {
        sendData = sendData.replace(item?.inputCharater, item?.outputCharater || '');
      })
    }
    onChange?.(sendData);
  };

  return (
    <AutoComplete
      value={value}
      options={options}
      // onSelect={onSelect}
      onSearch={onSearch}
      onChange={changeInput}
      popupClassName={isOnlyRead ? styles.autoComplete_select_content : ''}
      disabled={disabled}
      allowClear={allowClear !== false}
    />
  );
};

export const AutoCompleteInputMemo = memo(AutoCompleteInput);
